// Survey options and userType-tailored copy for the onboarding flow.

export const USER_TYPES = [
    { key: 'creator', label: 'Content Creator' },
    { key: 'musician', label: 'Musician / Artist' },
    { key: 'business', label: 'Business Owner' },
    { key: 'fun', label: 'Just for Fun' },
    { key: 'other', label: 'Other' },
]

export const REFERRAL_SOURCES = [
    { key: 'tiktok', label: 'TikTok' },
    { key: 'instagram', label: 'Instagram' },
    { key: 'twitter', label: 'Twitter / X' },
    { key: 'google', label: 'Google' },
    { key: 'reddit', label: 'Reddit' },
    { key: 'article', label: 'Article' },
    { key: 'friend', label: 'Friend' },
    { key: 'search', label: 'Search' },
    { key: 'other', label: 'Other' },
]

// Collapse the five user types into messaging buckets.
export function tailorBucket(userType) {
    if (userType === 'fun') return 'fun'
    return 'creator'
}

// Step 3 — "What Vibio Can Do For You": punchy value props per bucket.
const VALUE_PROPS = {
    creator: {
        heading: "It's more than a link in bio",
        props: [
            { title: "It's the video", desc: 'Draw attention with your personal brand and your energy.' },
            { title: "Link it all", desc: "Add your socials, calendars, storefronts or affiliates, anything you have." },
            { title: "Revenue Links", desc: 'See stats on the links that help you earn with revenue links.' },
            { title: "Brand Reports", desc: 'Turns your page and link stats into a report for your next partnership.' },
            { title: "Make it yours", desc: 'Customize your profile and page to match your brand.' },
        ],
    },
    fun: {
        heading: "Make a page that's all you!",
        props: [
            { title: "It's the video", desc: 'Video is what makes your page yours.' },
            { title: "Link it all", desc: 'Links, socials, calendars and your favorite stuff - all in one spot.' },
            { title: "See who's looking", desc: "Get insights on who's landing on your page." },
            { title: "Make it yours", desc: 'Fully customizable profile and page to match your vibe!' },
        ],
    },
}

export function getValueProps(userType) {
    return VALUE_PROPS[tailorBucket(userType)]
}

// Step 9 — tailored one-liner for the Pro pitch.
const PRO_PITCH = {
    creator: 'Understand your audience, track your revenue links, and create sponsor-ready brand reports — plus a verified badge and no Vibio branding.',
    fun: 'Want more? Add a verified badge, remove Vibio branding, and see deeper insights anytime.',
}

export function getProPitch(userType) {
    return PRO_PITCH[tailorBucket(userType)]
}
